export const SYNC_UPDATE_VALIDATION_SCHEMA = {
    contacts: ['id', 'created_at', 'updated_at', 'first_name'],
    products: ['id', 'created_at', 'updated_at', 'name'],
    product_sales_units: ['id'],
    product_sales_unit_regions: ['id'],
    procedures: [
        'id',
        'name',
        'category',
        'description',
        'price',
        'available',
        'created_at',
        'updated_at',
        'user_id',
    ],
    shopping_lists: ['id', 'created_at', 'updated_at', 'name'],
    shopping_list_products: [
        'id',
        'created_at',
        'updated_at',
        'shopping_list_id',
        'product_id',
        'unit_type',
        'quantity',
        'total_quantity',
    ],
    horses: ['id', 'created_at', 'updated_at', 'name'],
    horse_contacts: [
        'id',
        'created_at',
        'updated_at',
        'horse_id',
        'contact_id',
    ],
    invoices: [
        'id',
        'created_at',
        'updated_at',
        'amount_check',
        'status',
        'sent_to_contact_time',
    ],
    invoicing_products: [
        'id',
        'name',
        'price',
        'available',
        'user_id',
        'organisation_id',
        'created_at',
        'updated_at',
    ],
    invoice_invoicing_products: [
        'id',
        'user_id',
        'organisation_id',
        'invoice_id',
        'invoicing_product_id',
        'quantity',
        'created_at',
        'updated_at',
    ],
    events: ['id', 'created_at', 'updated_at', 'starts_time', 'ends_time'],
    event_horses: ['id', 'created_at', 'updated_at', 'event_id', 'horse_id'],
    event_users: [
        'id',
        'created_at',
        'updated_at',
        'event_id',
        'organisation_id',
    ],
    event_contacts: [
        'id',
        'created_at',
        'updated_at',
        'event_id',
        'contact_id',
    ],
    event_contact_reminders: [
        'id',
        'created_at',
        'updated_at',
        'event_contact_id',
        'time_before',
    ],
    entries: ['id', 'created_at', 'updated_at', 'logged_time', 'invoice_id'],
    entry_users: [
        'id',
        'created_at',
        'updated_at',
        'entry_id',
        'organisation_id',
    ],

    entry_procedures: [
        'id',
        'entry_id',
        'procedure_id',
        'created_at',
        'updated_at',
        'user_id',
        'name',
        'quantity',
        'price',
    ],
    entry_products: [
        'id',
        'created_at',
        'updated_at',
        'entry_id',
        'product_id',
        'quantity',
    ],
    inventory_products: ['id', 'created_at', 'updated_at', 'product_id'],
    inventory_changes: [
        'id',
        'created_at',
        'updated_at',
        'inventory_product_id',
        'quantity_change',
        'process_at',
        'user_id',
        'organisation_id',
    ],
    onboardings: ['id', 'created_at', 'updated_at'],
    users: ['id', 'created_at', 'updated_at'],
    organisations: ['id', 'created_at', 'updated_at'],
    organisation_accountings: ['id', 'created_at', 'updated_at'],
    organisation_users: ['id', 'created_at', 'updated_at'],
    organisation_user_colors: ['id', 'created_at', 'updated_at'],
    user_settings: ['id', 'created_at', 'updated_at', 'user_id', 'enabled'],
    regions: ['id'],
    device_calendar_events: [
        'id',
        'created_at',
        'updated_at',
        'user_id',
        'device_id',
        'event_id',
        'calendar_event_id',
    ],
    questions: ['id'],
    answers: ['id'],
    user_answers: ['id', 'created_at', 'updated_at', 'user_id', 'answer_id'],
    locations: [
        'id',
        'created_at',
        'updated_at',
        'name',
        'user_id',
        'place_id',
        'lat',
        'lng',
        'url',
        'utc_offset',
    ],
} as const;
